import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { queryClient } from './lib/query'
import { initSentry } from './lib/sentry'
import { installChunkErrorReporter } from './lib/chunkErrorReporter'
import './styles/tokens.css'
import './styles/animations.css'
import './styles/theme.css'
import './styles/global.css'
import './lib/i18n'

initSentry()
installChunkErrorReporter()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
